"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var prism_react_renderer_1 = __importStar(require("prism-react-renderer"));
var nightOwl_1 = __importDefault(require("prism-react-renderer/themes/nightOwl"));
var CodeBlock = function (_a) {
    var language = _a.language, value = _a.value;
    return value ? (React.createElement(prism_react_renderer_1["default"], __assign({}, prism_react_renderer_1.defaultProps, { code: value, language: language, theme: nightOwl_1["default"] }), function (_a) {
        var className = _a.className, style = _a.style, tokens = _a.tokens, getLineProps = _a.getLineProps, getTokenProps = _a.getTokenProps;
        return (React.createElement("pre", { className: "".concat(className, " sm:mx-0 -mx-5 sm:rounded-md rounded-none"), style: style }, tokens.map(function (line, i) { return (React.createElement("div", __assign({}, getLineProps({ line: line, key: i }), { style: { fontSize: '90%' } }), line.map(function (token, key) { return (React.createElement("span", __assign({}, getTokenProps({ token: token, key: key })))); }))); })));
    })) : null;
};
exports["default"] = CodeBlock;
